/** Sex values the add-patient and edit-profile menus are allowed to show. */
export const PATIENT_SEX_OPTIONS = [
  { label: '\u00a0', value: '' },
  { label: 'Female', value: 'female' },
  { label: 'Male', value: 'male' }
];

/**
 * Male and Female stay selected. Blank, and every other stored value, is not set.
 * Matching is case-insensitive so both `female` and `Female` count.
 */
export function selectablePatientSex(value?: string | null): '' | 'female' | 'male' {
  const key = (value ?? '').trim().toLowerCase();
  if (key === 'female' || key === 'male') return key;
  return '';
}

/** Label for a recorded sex, or nothing when the chart still needs one. */
export function recordedPatientSex(value?: string | null): 'Female' | 'Male' | undefined {
  const selected = selectablePatientSex(value);
  if (selected === 'female') return 'Female';
  if (selected === 'male') return 'Male';
  return undefined;
}
